/* eslint-disable no-shadow */
import axios from "axios";
import configs from "../configs.js";

const install = (Vue, { baseURL = configs.apiBase, interceptor }) => {
  const instance = axios.create({
    withCredentials: true,
    credentials: "include",
    baseURL,
  });
  interceptor(instance);
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return instance;
      },
    },
  });
};

export default install;
